// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import {
  mdiAccountCreditCard,
  mdiAccountGroup,
  mdiAirplaneClock,
  mdiAirplaneCog,
  mdiAirplanePlus,
  mdiAirplaneRemove,
  mdiAirplaneSearch,
  mdiAirplaneSettings,
  mdiAirplaneTakeoff,
  mdiAirport,
  mdiBagSuitcaseOutline,
  mdiBankCircle,
  mdiBookOpenPageVariantOutline,
  mdiBookshelf,
  mdiBriefcaseArrowLeftRight,
  mdiBriefcaseArrowLeftRightOutline,
  mdiCalendarAccount,
  mdiCalendarBadge,
  mdiCalendarMonthOutline,
  mdiCalendarMultiselect,
  mdiCardBulletedSettingsOutline,
  mdiCardSearchOutline,
  mdiCashRegister,
  mdiCashSync,
  mdiChartDonut,
  mdiClipboardList,
  mdiClockAlertOutline,
  mdiCoffeeToGo,
  mdiContentDuplicate,
  mdiCreditCardRefund,
  mdiDatabaseExportOutline,
  mdiDatabaseSyncOutline,
  mdiDiamondStone,
  mdiDoorClosed,
  mdiEmailPlusOutline,
  mdiFinance,
  mdiFoodOutline,
  mdiFormatListBulleted,
  mdiFormatListText,
  mdiGasStationOutline,
  mdiGroup,
  mdiHandshakeOutline,
  mdiHumanMaleBoard,
  mdiHumanMaleBoardPoll,
  mdiInvoiceTextArrowRight,
  mdiInvoiceTextEditOutline,
  mdiLightbulbOutline,
  mdiListBoxOutline,
  mdiLockOpenAlert,
  mdiMedalOutline,
  mdiMonitorScreenshot,
  mdiMovieOpenOutline,
  mdiNumeric9PlusBoxMultipleOutline,
  mdiPercentBox,
  mdiPirate,
  mdiProgressCheck,
  mdiReceiptText,
  mdiRemoteDesktop,
  mdiReplyOutline,
  mdiSeatPassenger,
  mdiShieldAccountVariantOutline,
  mdiShieldAirplaneOutline,
  mdiShieldPlusOutline,
  mdiShieldSyncOutline,
  mdiSignatureFreehand,
  mdiStackOverflow,
  mdiTableChair,
  mdiTankerTruck,
  mdiTelevision,
  mdiTextAccount,
  mdiTextRecognition,
  mdiTicketConfirmationOutline,
  mdiTicketOutline,
  mdiTools,
  mdiTooltipPlusOutline,
  mdiTowTruck,
  mdiTransfer,
  mdiTrayFull,
  mdiUndoVariant,
  mdiViewList,
  mdiWalletOutline,
  mdiWeightKilogram,
  mdiWrenchCogOutline,
} from "@mdi/js"; // or wherever your icons are coming from

// centralized mapping
export const iconMap: Record<string, string> = {
  mdiWeightKilogram,
  mdiTelevision,
  mdiBagSuitcaseOutline,
  mdiDoorClosed,
  mdiAirplaneCog,
  mdiTextRecognition,
  mdiMovieOpenOutline,
  mdiMonitorScreenshot,
  mdiAirplaneRemove,
  mdiHumanMaleBoard,
  mdiClockAlertOutline,
  mdiClipboardList,
  mdiDatabaseExportOutline,
  mdiWrenchCogOutline,
  mdiTransfer,
  mdiTextAccount,
  mdiBriefcaseArrowLeftRightOutline,
  mdiUndoVariant,
  mdiNumeric9PlusBoxMultipleOutline,
  mdiDatabaseSyncOutline,
  mdiGasStationOutline,
  mdiFormatListText,
  mdiInvoiceTextEditOutline,
  mdiTowTruck,
  mdiTankerTruck,
  mdiCalendarAccount,
  mdiPirate,
  mdiAccountGroup,
  mdiBankCircle,
  mdiBriefcaseArrowLeftRight,
  mdiReceiptText,
  mdiStackOverflow,
  mdiCalendarMultiselect,
  mdiAirplaneTakeoff,
  mdiTooltipPlusOutline,
  mdiReplyOutline,
  mdiListBoxOutline,
  mdiCashRegister,
  mdiShieldAirplaneOutline,
  mdiGroup,
  mdiCalendarMonthOutline,
  mdiTools,
  mdiSeatPassenger,
  mdiTrayFull,
  mdiEmailPlusOutline,
  mdiAirplanePlus,
  mdiInvoiceTextArrowRight,
  mdiPercentBox,
  mdiFinance,
  mdiCalendarBadge,
  mdiLockOpenAlert,
  mdiCardSearchOutline,
  mdiBookshelf,
  mdiViewList,
  mdiFormatListBulleted,
  mdiAirplaneSettings,
  mdiAirplaneSearch,
  mdiHumanMaleBoardPoll,
  mdiTicketOutline,
  mdiTicketConfirmationOutline,
  mdiCashSync,
  mdiCoffeeToGo,
  mdiAccountCreditCard,
  mdiCreditCardRefund,
  mdiBookOpenPageVariantOutline,
  mdiChartDonut,
  mdiAirplaneClock,
  mdiAirport,
  mdiTableChair,
  mdiFoodOutline,
  mdiRemoteDesktop,
  mdiSignatureFreehand,
  mdiHandshakeOutline,
  mdiMedalOutline,
  mdiContentDuplicate,
  mdiDiamondStone,
  mdiCardBulletedSettingsOutline,
  mdiWalletOutline,
  mdiLightbulbOutline,
  mdiShieldAccountVariantOutline,
  mdiShieldPlusOutline,
  mdiShieldSyncOutline,
  mdiProgressCheck,
};

export interface ItemAirline {
  idAirline: number;
  airline: string;
  value: string;
  label: string;
}
export interface ItemStatus {
  idStatus: number;
  isActiveStatus: number;
  status: string;
  value: string;
  label: string;
  statusES?: string;
  statusEN?: string;
  AODBTAG?: string;
  tipo?: string;
  jsonConfig?: any;

}
export interface ItemDisplay {
  idDisplay: number;
  idModule: number;
  display: string;
  orderDisplay: number;
  displayType: string;
  isActiveDisplay: number;
  lastCNX: string;
  AODBTAG: string;
  value: string;
  label: string;
  jsonConfig?: any;
  publishToSICNS?: number;
  hashDisplay?: string;
}
export interface ItemCounter {
  idCounter: number;
  counter: string;
  orderCounter: number;
  hub: string;
  isActiveCounter: number;
  AODBTAG: string;
  value: string;
  label: string;
}
export interface ItemGate {
  idGate: number;
  gate: string;
  orderGate: number;
  hub: string;
  isActiveGate: number;
  AODBTAG: string;
  value: string;
  label: string;
}
export interface ItemBelt {
  idBelt: number;
  belt: string;
  orderBelt: number;
  hub: string;
  isActiveBelt: number;
  AODBTAG: string;
  value: string;
  label: string;
}
export interface ItemAirport {
  idAirport: number;
  airport: string;
  IATA?: string;
  OACI?: string;
  city?: string;
  country?: string;
  GMT?: number;
  GMTNextSync?: string;
  GMTNextValue?: number;
  value: string;
  label: string;
  jsonConfig?: ItemConfigAirport;
}
export interface ItemConfigAirport {
  RMS?: {
    enableRMSUpdate?: number;
    thresholdReportTime?: number;
    reportingUsers?: string[];
  };
  status?: {
    enableUpdate?: number;
  };
  SICNS?: {
    publishToSICNS?: number;
    apiKey?: string;
  };
  IATA?: string;
  OACI?: string;
  city?: string;
  country?: string;
  GMT?: string;
  GMTNextSync?: string;
  GMTNextValue?: number;
  value: string;
  label: string;
  jsonConfig?: ItemConfigAirport;
  airports?: number[];
  airlines?: number[];
}

export interface MenuItem {
  text: string;
  idMenu: number;
  isFavorite: number;
  isSideMenu: number;
  type?: string;
  href?: string;
  section?: string;
  items?: MenuItem[];
  badge?: boolean;
  badgeVariable?: string;
  badgeColor?: string;
  title?: string;
  description?: string;
  icon?: string;
  id?: string;
  isBreadcrumb?: number;
  jsonRouting?: number[];
}


export type ItemFilter = {
  idUserTypes?: number[];
  idCharges?: number[];
  idBookingTypes?: number[],
  idGroupTypes?: number[],
  idCategories?: number[],
  idAccountPlans?: number[],
  idChecks?: number[],
  statusesRequest?: number[],
  idGroups?: number[],
  idUserStatuses?: number[],
  keyw?: string[];
  operator?: string;
};

export type ItemUserGroup = {
  idGroup: number;
  groupName: string;
  idAirport: number;
  jsonMenu: number[];
  label: string;
  value: string;
}
export type ItemUser = {


  idUser: number,
  userName: string,
  userEmail: string,
  dateLastLogin: string,
  dateCreated: string,
  isActiveUser: number,
  name: string,
  isSuspendedUser: number,
  userGroups?: number[],
  jsonGroups?: number[],

};

export interface BehaviorResource {
  precedence: string;
  pathPattern: string;
  origin: string;
  viewerProtocolPolicy: string;
  forwardedQueryStrings: string;
}

export interface LogResource {
  id: string;
  name: string;
  lastWritten: string;
  size: string;
}

export interface ContentOriginsResource {
  value: string;
  label: string;
}

export interface OriginResource {
  id: string;
  name: string;
  type: string;
  accessIdentity: string;
}
export interface InvalidationResource {
  id: string;
  status: string;
  date: string;
}

export interface DistributionResource {
  id: string;
  deliveryMethod: string;
  domainName: string;
  origin: string;
  priceClass: string;
  logging: string;
  sslCertificate: string;
  tags: { department: string[]; environment: string[] };
  date: Date;
  state?: 'Activated' | 'Deactivated';
}

export interface Tag {
  key: string;
  value: string;
}

export interface TagsResource {
  resourceTags: Tag[];
  valueMap: {
    owner: string[];
    project: string[];
    role: string[];
    performance: string[];
    profile: string[];
  };
}

export interface EC2Instance {
  id: string;
  type: string;
  publicDns: string;
  monitoring: string;
  state: string;
  platformDetails: string;
  terminalProtection: string;
  launchTime: string;
  volume: number;
  securityGroups: string[];
  loadBalancers: string[];
  availabilityZone: string;
  numOfvCpu: number;
  inboundRules: {
    type: string;
    protocol: string;
    portRange: string;
    source: string;
    description: string;
  }[];
}



export const weekDays = [
  { label: 'Lunes', value: '1', weekDay: 1, day: 'Lunes', short: 'L' },
  { label: 'Martes', value: '2', weekDay: 2, day: 'Martes', short: 'M' },
  { label: 'Miércoles', value: '3', weekDay: 3, day: 'Miércoles', short: 'X' },
  { label: 'Jueves', value: '4', weekDay: 4, day: 'Jueves', short: 'J' },
  { label: 'Viernes', value: '5', weekDay: 5, day: 'Viernes', short: 'V' },
  { label: 'Sábado', value: '6', weekDay: 6, day: 'Sábado', short: 'S' },
  { label: 'Domingo', value: '7', weekDay: 7, day: 'Domingo', short: 'D' },
  { label: 'Feriados', value: '0', weekDay: 0, day: 'Feriados', short: 'F' },
]

export interface OptionDefinition {
  label: string;
  value: string;
}

export interface ItemFlight {
  idFlight: number;
  idAirportOwner: number;
  idAirportOrigin: number;
  idAirportDestination: number;
  idAirline: number;

  boardingTime: string;
  boardingTimeReal: string;
  departureTime: string;
  departureTimeReal: string;
  arrivalTime: string;
  arrivalTimeReal: string;

  idStatus: number;
  idGate: number;
  idBelt: number;
  flightNumber: string;
  idFlightAODB: number;
  isActive: number;
  origin?: string;
  originAirport?: string;
  destination?: string;
  destinationAirport?: string;
  airline?: string;
  direction?: string;
  status?: string;
  gate?: string;
  belt?: string;
  isCancel: number;
  isDelete: number;
  isClosed: number;
  jsonRMS: any[];
  jsonSICNS: any[];
  arrivalDelta: number;
  departureDelta: number;
  boardingDelta: number;
  isRMSEnabled: number;
  isStatusUpdate: number;
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Use 'auto' for instant jump
  });
};